<!-- Show message when pivots are not supported for this chart type -->
<div class="datasource-container">
  @if (shouldShowNotSupportedMessage) {
    <div class="pivot-not-supported">
      <div class="alert alert-info" role="alert">
        <div class="alert-content">
          <fa-icon [icon]="['fas', 'info-circle']" class="alert-icon"></fa-icon>
          <div class="alert-text">
            <strong>{{
              "datasource-selector.alert.pivots-not-supported" | translate
            }}</strong>
            <p>
              {{
                "datasource-selector.alert.pivots-not-supported-description"
                  | translate
                    : {
                        chartType: $safeNavigationMigration(
                          widget?.chart_type?.name
                        ),
                      }
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Show normal datasource selector when pivots are supported or not a pivot selector -->
  @if (!shouldShowNotSupportedMessage) {
    <div class="datasource-selector">
      @if (isLoading) {
        <app-loading [size]="'2x'" [centered]="true"></app-loading>
      }
      @if (!isLoading) {
        <div>
          <div class="add-datasource">
            <sui-button
              variant="primary"
              [leadingIcon]="['fas', 'plus']"
              [suiTooltip]="
                'datasource-selector.tooltip.add-new-datasource' | translate
              "
              (click)="addNew()"
            >
              {{ addDatasourceButtonText | translate }}
            </sui-button>
          </div>
          @if (datasources.length == 0) {
            <div class="no-datasources">
              {{ noSelectionText | translate }}
            </div>
          }
          <div
            class="datasource-list"
            [appSortableList]="datasources"
            [sortableHandle]="'.draggable'"
            [dragThreshold]="5"
            [dragDelay]="150"
            (sorted)="onListUpdated($event)"
          >
            @for (datasource of datasources; track datasource; let i = $index) {
              <div class="datasource">
                <div class="heading">
                  <div class="draggable">
                    <fa-icon [icon]="['fas', 'arrows-alt-v']"></fa-icon>
                  </div>
                  <div class="title">
                    <app-selected-data-source
                      [datasource]="datasource"
                      [objectTypeIds]="objectTypeIds"
                      (datasourceChange)="replaceDatasource(i, $event)"
                    >
                    </app-selected-data-source>
                  </div>
                  <app-color-picker
                    [(ngModel)]="datasources[i].color"
                    [defaultObjectColor]="datasources[i].default_color"
                    (ngModelChange)="updateFormGroupValues()"
                  ></app-color-picker>
                  <sui-button
                    variant="secondary"
                    size="lg"
                    [leadingIcon]="'gear'"
                    [iconOnly]="true"
                    [ariaLabel]="
                      'widget-settings-popup.data-source.edit-settings'
                        | translate
                    "
                    [suiTooltip]="
                      'widget-settings-popup.data-source.edit-settings'
                        | translate
                    "
                    (click)="editDatasource(datasource)"
                  ></sui-button>
                  <sui-button
                    variant="secondary"
                    size="lg"
                    [leadingIcon]="'minus'"
                    [iconOnly]="true"
                    [ariaLabel]="
                      'datasource-selector.tooltip.remove' | translate
                    "
                    [suiTooltip]="
                      'datasource-selector.tooltip.remove' | translate
                    "
                    (click)="removeDatasource(datasource)"
                  ></sui-button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
